module.exports = __webpack_public_path__ + "static/media/onboard-2-connect.8ba61568.gif";